import axios from 'axios';

/**
 * Axios Request Interceptor
 * Automatically adds IC-REQUEST-SOURCE header to ALL axios requests
 * This allows the backend to identify requests originating from the Admin UI
 * and enables better tracking, logging, and monitoring.
 */
axios.interceptors.request.use(
  config => {
    config.headers = config.headers || {}; // defensive initialization in-case headers are undefined
    if (!config.skipRequestSource) {
      config.headers['IC-REQUEST-SOURCE'] = 'UI-ADMIN';
    }
    if (sessionStorage.getItem('tokenType') === 'bearer') {
      const token = sessionStorage.getItem('token');
      delete config.headers['X-IC-ACCESS-TOKEN'];
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 504) {
      error.message = 'The request took too long and timed out.';
    }
    return Promise.reject(error);
  }
);

/**
 * Base class fro APIs
 */
class ApiBase {
  API_URL = 'v1';

  /**
   * Get standard headers for API calls
   */
  getHeaders() {
    const token = sessionStorage.getItem('token');
    const tenant = sessionStorage.getItem('tenant');

    return {
      'Content-Type': 'application/json',
      'IC-USER-CLIENT': Buffer.from(tenant).toString('base64'),
      'X-IC-ACCESS-TOKEN': token
    };
  }
}

export default ApiBase;
